module.exports = __webpack_public_path__ + "static/media/WechatIMG5.d0289dc0.png";